import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allUsers,
  allRoles,
  MerchandiseComplianceReport,
  ExportMerchandiseComplianceReport,
} from "../ReportData";
import FilterListIcon from "@mui/icons-material/FilterList";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import OptionConvert from "../../../components/OptionConvert";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import URL from "../../../../pages/Utils/url";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../../report/ReportStateMange";
import ReusableFilter from "../../../components/ReusableFilter";

import { getallmall } from "../../productDisplayCompliance/api/query";

function MerchandiseCompliance() {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [customerTargerData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState
  );
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setData] = useState([]);
  const [value, setValue] = useState(0);
  const [agentOptions, setAgentOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [roleOptions, setRoleOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [marketOptions, setMarketOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [quantityOptions, setQuantityOptions] = useState([
    { label: "All", value: "All" },
  ]);

  const [dialogOpen, setDialogOpen] = useState(false);
  // Pagination state for graph view
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 5;

  useEffect(() => {
    fetchRoles();
    fetchAgentName();
    fetchAllStockExpiry();
    // fetchCustomerTargerData();
  }, []);

  //   const processOverallData = (data) => {
  //   let assignedCustomers = 0;
  //   let achievedCustomers = 0;

  //   data.forEach(({ completedCount, incompletedCount }) => {
  //     if (completedCount) assignedCustomers += 1;
  //     if (incompletedCount) achievedCustomers += 1;
  //   });

  //   return [
  //     {
  //       category: "Summary",
  //       assignedCustomers,
  //       achievedCustomers,
  //     },
  //   ];
  // };

  //get table data
  const fetchAllStockExpiry = () => {
    setIsLoading(true);

    request(BASEURL, getallmall)
      .then((res) => {
        const market = OptionConvert(
          res?.allMallEntriesList,
          "marketName",
          "id"
        );
        // const quantity=OptionConvert(res?.allMallEntries, "quantity", "id");
        const quantity = res?.allMallEntriesList?.flatMap((entry) =>
          entry.agreedProducts.map((product) => ({
            label: product.quantity,
            value: product.id,
          }))
        );

        setMarketOptions((prevOptions) => [...prevOptions, ...market]);
        setQuantityOptions((prevOptions) => [...prevOptions, ...quantity]);
        // resetPagination();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //  const transformedData = processOverallData(datas);

  // Calculate pagination values
  const totalPages = Math.ceil(datas.length / recordsPerPage);

  const currentData = datas.slice(
    currentPage * recordsPerPage,
    (currentPage + 1) * recordsPerPage
  );

  // Pagination handlers

  const handlePrevious = () => setCurrentPage((prev) => Math.max(prev - 1, 0));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));

  // Reset pagination when data changes
  const resetPagination = () => {
    setCurrentPage(0);
  };

  //table row and colomn
  const customerTargetListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Market Name",
        field: "marketName",
        name: "marketName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Agent Name",
        field: "agentName",
        name: "agentName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "product Name",
        field: "productName",
        name: "productName",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Agreed Quantity",
        field: "agreedQuantity",
        name: "agreedQuantity",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Actual Quantity",
        field: "actualQuantity",
        name: "actualQuantity",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Batch Expiry",
        field: "batchExpiry",
        name: "batchExpiry",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Remarks",
        field: "remarks",
        name: "remarks",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: datas.map((v, i) => ({
      sno: i + 1,
      id: i + 1,
      marketName: v?.marketName,
      agentName: v?.agentName,
      productName: v?.productName,
      agreedQuantity: v?.agreedQuantity,
      actualQuantity: v?.actualQuantity,
      batchExpiry: v?.batchExpiry,
      remarks: v?.remarks,
    })),
  };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    // fetchCustomerTargerData();
    setData([]);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //download file
  const handleDownload = (startDate, endDate, roles, agentsName) => {
    const roleIds =
      roles?.length > 0 ? roles?.map((item) => item.value) || [] : [];
    const agents =
      agentsName?.length > 0 && !agentsName.some((item) => item.value === "All")
        ? agentsName.map((item) => item.value) || []
        : [];

    setCirleLoading(true);
    request(BASEURL, ExportMerchandiseComplianceReport, {
      startDate,
      endDate,
      roleIds,
      agents,
    })
      .then(async (res) => {
        const status = res?.exportMerchandiseComplianceReport?.success;

        const pdfurl = `${URL}${res?.exportMerchandiseComplianceReport?.fileUrl?.slice(
          1
        )}`;

        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "merchandiseCompliance.xlsx"
          );
          setCirleLoading(false);
        }
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  //get customer option
  const fetchRoles = () => {
    setIsLoading(true);
    request(BASEURL, allRoles)
      .then((res) => {
        const roleData = res?.allRoles[0]?.data;
        const customer = OptionConvert(roleData, "role", "id");
        setRoleOptions((prevOptions) => [...prevOptions, ...customer]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //get agent name option
  const fetchAgentName = () => {
    setIsLoading(true);
    request(BASEURL, allUsers)
      .then((res) => {
        const productName = OptionConvert(res?.allUsers, "employeeName", "id");
        setAgentOptions((prevOptions) => [...prevOptions, ...productName]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //get table data
  const fetchCustomerTargerData = () => {
    setIsLoading(true);
    const payload = {
      startDate: "",
      endDate: "",
      roleIds: [],
      agentIds: [],
    };
    request(BASEURL, MerchandiseComplianceReport, payload)
      .then((res) => {
        const newdata = res?.getMerchandiseComplianceReport.data;
        setData(newdata);
        resetPagination();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //filter api call
  const filterCustomerTargerData = (
    startDate,
    endDate,
    agents,
    quantity,
    market
  ) => {
    setIsLoading(true);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      agentIds: agents,
      actualQuantityPercents: quantity,
      marketNames: market,
    };

    request(BASEURL, MerchandiseComplianceReport, payload)
      .then((res) => {
        const newdata = res?.getMerchandiseComplianceReport?.data;
        setData(newdata);
        resetPagination();
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  //filter submit
  const submitFilter = (data) => {
    const agentName =
      customerTargerData?.agentName?.length > 0 &&
      !customerTargerData.agentName.some((item) => item.value === "All")
        ? customerTargerData.agentName.map((item) => item.value)
        : [];

    const roles =
      customerTargerData?.roleName?.length > 0
        ? customerTargerData?.roleName.map((item) => item.value)
        : [];
    const quantity =
      customerTargerData?.quantity?.length > 0
        ? customerTargerData?.quantity.map((item) => item.label)
        : [];
    const market =
      customerTargerData?.market?.length > 0
        ? customerTargerData?.market.map((item) => item.label)
        : [];

    filterCustomerTargerData(
      customerTargerData.fromDate,
      customerTargerData.toDate,
      agentName,
      quantity,
      market
    );
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Merchandise Compliance List
                </MaterialTypography>
              </Stack>
              {customerTargerData?.fromDate && customerTargerData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      customerTargerData?.fromDate,
                      customerTargerData?.toDate,
                      customerTargerData?.roleName,
                      customerTargerData?.agentName
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />
        {/* taps */}
        <Box sx={{ my: "5px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Box sx={{ width: "50%", bgcolor: "background.paper" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#2a9941",
                    color: "white",
                  },
                }}
                centered
              >
                <Tab label="Table list view" />
                <Tab label="Graph view" />
              </Tabs>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                bgcolor: "background.paper",
              }}
            >
              <IconButton
                onClick={() => setDialogOpen(true)}
                aria-label="Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <FilterListIcon fontSize="large" />
              </IconButton>
              <IconButton
                onClick={resetFilters}
                aria-label="Reset Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <RefreshIcon fontSize="large" />
              </IconButton>
            </Box>
          </Stack>
        </Box>

        {/* filter fields */}
        {/* <Box sx={{ my: "5px" }}>
          <Grid container spacing={2} p={1}>
            <Grid size={{ xs: 12, sm: 2.5 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  From Date 
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                size="small"
                name="fromDate"
                value={customerTargerData?.fromDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "fromDate" })
                }
                error={dateerror ? true : false}
              />
              <span style={{ color: "red", fontSize: "12px" }}>
                {" "}
                {dateerror}
              </span>
            </Grid>

            <Grid size={{ xs: 12, sm: 2.5 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  To Date 
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="date"
                size="small"
                name="toDate"
                value={customerTargerData?.toDate}
                onChange={(e) =>
                  dispatch({ value: e?.target?.value, name: "toDate" })
                }
              />
              {error && (
                <MaterialTypography
                  color="error"
                  variant="caption"
                  display="block"
                  mt={1}
                >
                  {error}
                </MaterialTypography>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Agent Name 
                </MaterialTypography>
              </MaterialBox>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={agentOptions || []}
                getOptionLabel={(option) => option.label || ""}
                value={customerTargerData?.agentName || []}
                onChange={(event, newValue) => {
                  dispatch({ value: newValue, name: "agentName" });
                }}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  (selected || []).map((option, index) => (
                    <Chip
                      key={index}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Category(s)"
                    size="small"
                  />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Role 
                </MaterialTypography>
              </MaterialBox>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={roleOptions || []}
                getOptionLabel={(option) => option.label || ""}
                value={customerTargerData?.customerName || []}
                onChange={(event, newValue) => {
                  dispatch({ value: newValue, name: "customerName" });
                }}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  (selected || []).map((option, index) => (
                    <Chip
                      key={index}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Category(s)"
                    size="small"
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 1 }}>
              <IconButton
                onClick={resetFilters}
                aria-label="Reset Filters"
                color="primary"
                sx={{ mt: 2 }}
              >
                <RefreshIcon fontSize="large" />
              </IconButton>
            </Grid>
          </Grid>
        </Box> */}

        <ReusableFilter
          data={customerTargerData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              customerTargerData,
            })
          }
          title="Merchandise Compliance Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agent Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={agentOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={customerTargerData?.agentName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "agentName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          {/* <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Role Name 
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={roleOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={customerTargerData?.roleName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "roleName" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Role(s)" />
              )}
            />
          </Grid> */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Market Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={marketOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={customerTargerData?.market || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "market" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Market(s)" />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Quantity
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={quantityOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={customerTargerData?.quantity || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "quantity" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Quantity(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>

        {value === 0 ? (
          //Table list view
          <Box>
            {!isLoading && (
              <MaterialDataGrid
                rows={customerTargetListTable?.rows}
                columns={customerTargetListTable?.columns}
                isSelectable={false}
                localeText={{
                  noRowsLabel: (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                      <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                      >
                        No results match your filters
                      </MaterialTypography>

                      <MaterialTypography variant="caption" color="text">
                        Try adjusting or clearing the filters to see Merchandise
                        Compliance data.
                      </MaterialTypography>
                    </Stack>
                  ),
                }}
              />
            )}
          </Box>
        ) : (
          //graph list view with pagination
          <Box>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                data={currentData}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                barSize={30}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="customerName" />
                <YAxis />
                <Tooltip
                  contentStyle={{
                    fontSize: "12px",
                    borderRadius: "8px",
                    background: "rgba(255, 255, 255, 0.8)",
                    border: "1px solid #ccc",
                    padding: "2px",
                  }}
                  wrapperStyle={{
                    outline: "none",
                  }}
                />
                <Legend wrapperStyle={{ fontSize: "12px" }} />
                <Bar
                  dataKey="agreedQuantity"
                  fill="#8884d8"
                  name="Agreed Quantity"
                />
                <Bar
                  dataKey="actualQuantity"
                  fill="#2a9941"
                  name="Actual Quantity"
                />
              </BarChart>
            </ResponsiveContainer>

            {/* Pagination controls */}
            <Box display="flex" justifyContent="center" mt={2} mb={2}>
              <IconButton
                onClick={handlePrevious}
                disabled={currentPage === 0}
                aria-label="previous page"
              >
                <ArrowBackIosIcon />
              </IconButton>
              <Typography variant="body1" mx={2}>
                Page {currentPage + 1} of {totalPages}
              </Typography>
              <IconButton
                onClick={handleNext}
                disabled={currentPage >= totalPages - 1}
                aria-label="next page"
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>
          </Box>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}

export default MerchandiseCompliance;
